// extracted by mini-css-extract-plugin
export default {"input":"Editable_input__1M6Du","files":"Editable_files__XUO91","files__icon":"Editable_files__icon__HbcRm"};